import axios from 'axios';
import store from '../store';
import router from '../router'
import QS from 'qs'
import { Toast } from 'vant';
// 环境的切换
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = '/api'
} else if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'https://api.mayiic.com/mobilemall/'
}

// 请求拦截器
axios.interceptors.request.use(
    config => {
        store.commit('showLoading')
        let token = localStorage.getItem('token')
        token && (config.headers.Authorization = token)
        return config
    },
    error => {
        store.commit('hideLoading')
        return Promise.error(error)
    })

axios.defaults.timeout = 10000

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// 响应拦截
axios.interceptors.response.use(
    response => {
        if (response.status == 200) {
            store.commit('hideLoading')
            return Promise.resolve(response);
        }
        else {
            return Promise.reject(response);
        }
    },
    error => {
        store.commit('hideLoading')
        if (error.response) {
            switch (error.response.status) {
                case 204:
                    this.$toast('请先登录')
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                    break;
                case 203:
                    this.$toast({
                        message: '登录超时',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                default:
                    this.$toast({
                        message: error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
)

//get请求
export function get({
    url,
    params = {}
}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params
        }).then((res) => {
            if (res.data.status == 204) {
                Toast({
                    message: '请先登录'
                })
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


// export function post({
//     url,
//     data = {},
//     params = {}
// }) {
//     return new Promise((resolve, reject) => {
//         axios({
//             url,
//             method: 'post',
//             transformRequest: [function (data) {
//                 let ret = ''
//                 for (let it in data) {
//                     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//                 }
//                 return ret
//             }],
//             // 发送的数据
//             data,
//             // url参数
//             params

//         }).then(res => {
//             resolve(res.data)
//         })
//     })
// }

// post请求
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                if (res.data.status == 204) {
                    Toast({
                        message: '请先登录'
                    })
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                }
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

//put请求
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                if (res.data.status == 204) {
                    Toast({
                        message: '请先登录'
                    })
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                }
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

//delete请求
export function deletes(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, params)
            .then(res => {
                if (res.data.status == 204) {
                    Toast({
                        message: '请先登录'
                    })
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                }
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}



